import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import { getIdTokenLocalStorage, isJwtValid } from './jwt';

function ProtectedRoute({ component: Component, loginURL, ...rest }) {
  const token = getIdTokenLocalStorage();
  const isValid = isJwtValid(token);

  if (isValid) {
    return (
      <Route
        {...rest}
        render={props => <Component {...props} />}
      />
    );
  }

  return window.location.replace(loginURL);
}

ProtectedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  loginURL: PropTypes.string.isRequired,
};

export default ProtectedRoute;
